// oxlint-disable prisma/headings
import type { FC, HTMLAttributes } from 'react';
import { cn } from 'src/utils/cn';

type BaseProps = HTMLAttributes<HTMLHeadingElement>;

type HeadlineModeProps = { mode: 'headline'; size: 'md' | 'lg' };

type TitleModeProps = { mode: 'title'; size: 'sm' | 'md' };

// Can be deleted after the rollout of the new design, it only supports the legacy design
type FooterModeProps = { mode: 'footer'; size?: never };

export type Props = (HeadlineModeProps | TitleModeProps | FooterModeProps) &
  BaseProps;

const baseHeadlineStyles = cn(`
  font-family-headline font-headline
  text-foreground-default
`);

const baseTitleStyles = cn(`
  font-family-title font-title
  text-foreground-default
`);

export const Heading: FC<Props> = ({ mode, size, ...props }) => {
  switch (mode) {
    case 'footer':
      return <h4 {...props} />;

    case 'headline':
      switch (size) {
        case 'lg':
          return (
            <h1
              {...props}
              className={cn(
                baseHeadlineStyles,
                'text-headline-lg',
                props.className
              )}
            />
          );

        case 'md':
          return (
            <h2
              {...props}
              className={cn(
                baseHeadlineStyles,
                'text-headline-md',
                props.className
              )}
            />
          );
      }

    case 'title':
      switch (size) {
        case 'md':
          return (
            <h3
              {...props}
              className={cn(baseTitleStyles, 'text-title-md', props.className)}
            />
          );

        case 'sm':
          return (
            <h4
              {...props}
              className={cn(baseTitleStyles, 'text-title-sm', props.className)}
            />
          );
      }
  }
};
